import React from "react";
import { Col, DatePicker, Form, Input, InputNumber, Row, Select } from "antd";

const CURRENCY_OPTIONS = ["USD", "EUR", "CNY", "MNT", "RUB"].map((item) => ({
    label: item,
    value: item,
}));

/**
 * The Гүйлгээний төлөвлөгөө field set, shared by manual entry and the admin edit modal so both
 * forms stay identical in layout and validation.
 */
function TransactionPlanFormFields({ t }) {
    return (
        <Row gutter={[16, 0]}>
            <Col xs={24} md={12}>
                <Form.Item
                    label={t("col.sender")}
                    name="sender"
                    rules={[
                        { required: true, message: t("req.sender") },
                        { max: 255, message: t("req.max255") },
                    ]}
                >
                    <Input placeholder={t("manual.ph.sender")} allowClear />
                </Form.Item>
            </Col>

            <Col xs={24} md={12}>
                <Form.Item
                    label={t("col.beneficiary")}
                    name="beneficiary"
                    rules={[
                        { required: true, message: t("req.beneficiary") },
                        { max: 255, message: t("req.max255") },
                    ]}
                >
                    <Input placeholder={t("manual.ph.beneficiary")} allowClear />
                </Form.Item>
            </Col>

            <Col xs={24} md={10}>
                <Form.Item
                    label={t("col.beneficiaryBank")}
                    name="beneficiaryBank"
                    rules={[{ max: 255, message: t("req.max255") }]}
                >
                    <Input placeholder={t("manual.ph.beneficiaryBank")} allowClear />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={5}>
                <Form.Item
                    label={t("col.executionDate")}
                    name="executionDate"
                    rules={[{ required: true, message: t("req.date") }]}
                >
                    <DatePicker
                        style={{ width: "100%" }}
                        format="YYYY-MM-DD"
                        placeholder={t("manual.ph.date")}
                    />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={4}>
                <Form.Item
                    label={t("col.currency")}
                    name="currency"
                    rules={[{ required: true, message: t("req.currency") }]}
                >
                    <Select
                        placeholder={t("col.currency")}
                        options={CURRENCY_OPTIONS}
                        showSearch
                        allowClear
                    />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={5}>
                <Form.Item
                    label={t("col.amount")}
                    name="amount"
                    rules={[
                        { required: true, message: t("req.amount") },
                        { type: "number", min: 0.01, message: t("req.amountPositive") },
                    ]}
                >
                    <InputNumber
                        style={{ width: "100%" }}
                        placeholder="0.00"
                        precision={2}
                        min={0.01}
                        step={0.01}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        parser={(value) => `${value}`.replace(/,/g, "")}
                    />
                </Form.Item>
            </Col>

        </Row>
    );
}

export default TransactionPlanFormFields;
